import { ThumbaGiftPointIcon } from "@roman/shared/components/Icons";
import type { WebUser } from "@roman/shared/types/WebUser";
import { pointsToMiraiMile } from "@roman/shared/utils/pointsToMiraiMile";

export const RedeemablePointsHeader = ({ user }: { user: WebUser }) => {
  const mile = pointsToMiraiMile(user.redeemablePoints);
  const mileNumber = Number(mile.replace(/,/g, ""));
  const textSize =
    mileNumber >= 10000000 ? "text-xs md:text-base" : mileNumber >= 100000 ? "text-sm md:text-base" : "text-base";
  return (
    <div className="gap-1 h-[36px] md:h-[40px] px-2 bg-[#F3F4FF] hover:bg-[#F3F4FF]/70 font-bold flex justify-center items-center rounded-full border border-[#E7EBEE]">
      <ThumbaGiftPointIcon className="h-[22px]" />
      <span className={`${textSize} text-black text-base font-semibold font-roboto`}>{mile}</span>
    </div>
  );
};
